//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../GeometricUtilities/GeometricUtilities.LawBuilder.js";
import "../no/Section.js";
import "../no/ScCollector.js";
import "../GeometricUtilities/GeometricUtilities.Continuity.js";
import "../no/Expression.js";
import "../Features/Features.SelectFeature.js";
import "../no/Expression.js";
import "../no/GeometricUtilities.js";
import "../no/ScCollector.js";
import "../no/Section.js";
import "../no/SelectObject.js";
let d=[[[1,"AngleLaw",0,"GeometricUtilities.LawBuilder",0],[1,"BaseCurves",0,"Section",0],[1,"BaseFaces",0,"ScCollector",0],[0,"BaseFactor",1,0],[1,"BasePipeContinuity",0,"GeometricUtilities.Continuity",0],[0,"CreateCurves",1,0],[0,"ExtendFlange",1,0],[0,"FlangeFactor",1,0],[1,"FlangePipeContinuity",0,"GeometricUtilities.Continuity",0],[1,"Gap",0,"Expression",0],[1,"LengthLaw",0,"GeometricUtilities.LawBuilder",0],[0,"MergeFacesIfPossible",1,0],[0,"OutputSurfaceOption",1,0],[1,"ParentFeature",0,"Features.SelectFeature",0],[0,"PositionTolerance",1,0],[1,"RadiusLaw",0,"GeometricUtilities.LawBuilder",0],[0,"ReferenceDirectionOption",1,0],[1,"ReferenceFaces",0,"ScCollector",0],[0,"ReferenceVector",1,"Direction",0],[0,"ShowPipe",1,0],[0,"TangentTolerance",1,0],[0,"TrimBaseFaces",1,0],[0,"Type",1,0]],[[[],"UpdateLawSpine",{},0,0],[[],"GetIsDirectionFlipped",{R_:{flipDirection:''}},0,0],[["flipDirection"],"SetIsDirectionFlipped",{},1,0],[[],"GetIsSideFlipped",{R_:{flipSide:''}},0,0],[["flipSide"],"SetIsSideFlipped",{},1,0],[[],"GetCenterCurve",{R_:{centerCurveTag:"Curve"}},0,0],[[],"GetSilhouetteCurve",{R_:{silhouetteCurveTag:"Curve"}},0,0],[[],"CreatePipe",{},0,0]],[]];
SPLM.Features.SilhouetteFlangeBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.SilhouetteFlangeBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.SilhouetteFlangeBuilder.Types = Object.freeze({
    "Basic" : "Basic", "AbsoluteGap" : "AbsoluteGap", "VisualGap" : "VisualGap"});

SPLM.Features.SilhouetteFlangeBuilder.ReferenceDirectionOptions = Object.freeze({
    "FaceNormal" : "FaceNormal", "Vector" : "Vector", "NormalDraft" : "NormalDraft", "VectorDraft" : "VectorDraft"});

SPLM.Features.SilhouetteFlangeBuilder.OutputSurfaceOptions = Object.freeze({
    "BlendFlange" : "BlendFlange", "PipeOnly" : "PipeOnly", "FlangeOnly" : "FlangeOnly"});

export default SPLM;